import * as tslib_1 from "tslib";
import { PruHttpService } from '../pru-http.service';
import { AggregationService } from '../../services/aggregation.service';
import { HomeinitService } from '../homeinit.service';
import { SessionStorageService } from '../web-storage/session-storage.service';
import { deferredWarmupMappings } from './deferred-warmup-mappings';
import * as i0 from "@angular/core";
import * as i1 from "../web-storage/session-storage.service";
import * as i2 from "../pru-http.service";
import * as i3 from "../aggregation.service";
import * as i4 from "../homeinit.service";
var DeferredWarmupService = /** @class */ (function () {
    function DeferredWarmupService(sessionStorageService, pruHttpService, aggregationService, homeinitService) {
        this.sessionStorageService = sessionStorageService;
        this.pruHttpService = pruHttpService;
        this.aggregationService = aggregationService;
        this.homeinitService = homeinitService;
        this.AGGREGATION_EVENT = 'aggregationDone';
        this.INITIATION_MARKER = 'maDefWarmDone';
    }
    DeferredWarmupService.prototype.init = function () {
        var _this = this;
        this.aggregationService.aggregationDone.subscribe(function (res) {
            if (res && res === _this.AGGREGATION_EVENT) {
                _this.startDeferredWarmup();
            }
        });
    };
    DeferredWarmupService.prototype.startDeferredWarmup = function () {
        var e_1, _a;
        if (this.sessionStorageService.getItem(this.INITIATION_MARKER)) {
            return;
        }
        var buNames = (this.homeinitService.appConfiguration && this.homeinitService.appConfiguration.buNames) || [];
        if (buNames.length === 0) {
            return;
        }
        var isAnyBUTriggered = false;
        try {
            for (var buNames_1 = tslib_1.__values(buNames), buNames_1_1 = buNames_1.next(); !buNames_1_1.done; buNames_1_1 = buNames_1.next()) {
                var buName = buNames_1_1.value;
                var mappingInfo = this.getMappingByBU(buName);
                if (mappingInfo) {
                    this.deferWarmupBU(mappingInfo);
                    isAnyBUTriggered = true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (buNames_1_1 && !buNames_1_1.done && (_a = buNames_1.return)) _a.call(buNames_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (isAnyBUTriggered) {
            this.sessionStorageService.setItem(this.INITIATION_MARKER, 'Y');
        }
    };
    DeferredWarmupService.prototype.deferWarmupBU = function (mappingInfo) {
        this.pruHttpService.get(mappingInfo.apiUrl, 'DeferredWarmup').subscribe(function () { });
    };
    DeferredWarmupService.prototype.getMappingByBU = function (buName) {
        return deferredWarmupMappings[buName.toLowerCase()];
    };
    DeferredWarmupService.ngInjectableDef = i0.defineInjectable({ factory: function DeferredWarmupService_Factory() { return new DeferredWarmupService(i0.inject(i1.SessionStorageService), i0.inject(i2.PruHttpService), i0.inject(i3.AggregationService), i0.inject(i4.HomeinitService)); }, token: DeferredWarmupService, providedIn: "root" });
    return DeferredWarmupService;
}());
export { DeferredWarmupService };
